import i18n from '@/plugins/i18n';
export const forms = [
    {
        type: 'select',
        name: 'subscription',
        title: i18n.t('customer.subs.subscription'),
        rules: {required: true},
        modal: ['customerSub','sub_id'],
        data: [ 'sub'],
        options: {
            data: [],
            label: 'name',
            track: 'id'
        },
        additionalButton: {
            icon: 'plus',
            variant: 'primary',
            size: 'sm',
            title: i18n.t('general.add'),
            type: 'Defination',
        },
        checkBox: false
    },
    {
        type: 'date',
        name: 'beginDate',
        title: i18n.t('customer.subs.beginDate'),
        format:'YYYY-MM-DD',
        rules: {required: true },
        modal: ['customerSub','begin_date'],
        data: ['begin_date'],
        nextField: 'endDate',
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'date',
        name: 'endDate',
        title: i18n.t('customer.subs.endDate'),
        format:'YYYY-MM-DD',
        rules: {required: true },
        modal: ['customerSub','end_date'],
        data: ['end_date'],
        additionalButton: false,
        checkBox: false
    },
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/General/Customer/forms/subscriptionForm.js